import { render, staticRenderFns } from "./TagsFilterTable.vue?vue&type=template&id=90cc538a&"
import script from "./TagsFilterTable.vue?vue&type=script&lang=js&"
export * from "./TagsFilterTable.vue?vue&type=script&lang=js&"
import style0 from "./TagsFilterTable.vue?vue&type=style&index=0&id=90cc538a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports